// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    'recurring-journal-entry-batch.page.title': 'Recurring Journal Entries',
    'recurring-journal-entry-batch.page.search_results': 'Search Results',
    'recurring-journal-entry-batch.page.search.title': 'Search Entries',
    'recurring-journal-entry-batch.page.view.title': 'View Entry',
    'recurring-journal-entry-batch.page.all': 'All',

    'recurring-journal-entry-batch.button.find': 'Find Recurring Journal Entries',
    'recurring-journal-entry-batch.button.search': 'Apply',
    'recurring-journal-entry-batch.button.reset': 'Reset',
    'recurring-journal-entry-batch.button.cancel_journal_entry_batch': 'Cancel Schedule',

    'recurring-journal-entry-batch.modal.title.recurring_journal_entry_batch_cancel': 'Cancel Recurring Journal Entry',
    'recurring-journal-entry-batch.modal.message.recurring_journal_entry_batch_cancel': 'Are you sure you want to cancel this recurring journal entry? This action cannot be undone.',
    'recurring-journal-entry-batch.button.confirm': 'Confirm',
    'recurring-journal-entry-batch.button.cancel': 'Cancel',

    'recurring-journal-entry-batch.placeholder.search': 'Search Recurring Journal Entries',

    'recurring-journal-entry-batch.link.create_first_journal_entry_batch': 'Click here to create your first recurring journal entry',
    'recurring-journal-entry-batch.link.retry': 'Click here to retry',

    'recurring-journal-entry-batch.checkbox.all': 'Check All',
    'recurring-journal-entry-batch.checkbox.actions_label': 'with selected',

    'recurring-journal-entry-batch.label.account': 'Account',
    'recurring-journal-entry-batch.label.debit': 'Debit',
    'recurring-journal-entry-batch.label.credit': 'Credit',
    'recurring-journal-entry-batch.label.memo': 'Memo',
    'recurring-journal-entry-batch.label.contact': 'Contact',
    'recurring-journal-entry-batch.label.from_date': 'From Date',
    'recurring-journal-entry-batch.label.thru_date': 'Thru Date',

    'recurring-journal-entry-batch.label.from_from_date': 'From From Date',
    'recurring-journal-entry-batch.label.to_from_date': 'To From Date',
    'recurring-journal-entry-batch.label.from_thru_date': 'From Thru Date',
    'recurring-journal-entry-batch.label.to_thru_date': 'To Thru Date',

    'recurring-journal-entry-batch.sort.field_label': 'Field',
    'recurring-journal-entry-batch.sort.direction_label': 'Direction',
    'recurring-journal-entry-batch.sort.direction_ascending': 'Ascending',
    'recurring-journal-entry-batch.sort.direction_descending': 'Descending',
    'recurring-journal-entry-batch.label.recurring_batch_no': 'Recurring Entry No',

    'recurring-journal-entry-batch.error.message.error_loading_page': 'Sorry, there was an error loading recurring journal entry.| Sorry, there was an error loading journal entries.',
    'recurring-journal_entry_batch.success.message.recurring_journal_entry_batch_cancelled': 'Recurring journal entry has been cancelled successfully.|Recurring journal entries have been cancelled successfully.',
};
